import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page news-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "page-eyebrow" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "news-card glass-card" }
const _hoisted_6 = { class: "news-label" }
const _hoisted_7 = { class: "news-tag" }
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventsCalendar = _resolveComponent("EventsCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_EventsCalendar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.jsonData.eyebrowLatest), 1),
      _createElementVNode("h1", {
        innerHTML: _ctx.jsonData.news
      }, null, 8, _hoisted_4),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "news-dot" }, null, -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.jsonData.newsAnnouncementLabel), 1)
      ]),
      _createElementVNode("div", {
        class: "news-text",
        innerHTML: _ctx.jsonData.newsText
      }, null, 8, _hoisted_8)
    ])
  ]))
}